"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSuggestions = void 0;
const input_1 = require("@pulse-web-ui/input");
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const http_cache_1 = require("./http-cache");
const react_dadata_styles_1 = require("./react-dadata.styles");
const request_1 = require("./request");
require("./types");
const utils_1 = require("./utils");
const PADDING_OVERFLOW = 5;
const DIMENSION = 'px';
class BaseSuggestions extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.loadSuggestionsUrl = '';
        this.dontPerformBlurHandler = false;
        this.headers = Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, this.props.headers);
        this.getInitialValues = () => {
            const { token, initialValue, onChange, customRequest, setIsLoading, setIsEmptySuggestions, isDisableRequests, } = this.props;
            if (token) {
                this.headers = Object.assign(Object.assign({}, this.headers), { Authorization: `Token ${token}` });
            }
            if (!isDisableRequests) {
                (0, request_1.makeRequest)('POST', this.getSuggestionsUrl(), {
                    headers: this.headers,
                    json: Object.assign(Object.assign({}, this.getLoadSuggestionsData()), { query: initialValue }),
                }, this.httpCache, (suggestions) => {
                    var _a, _b, _c;
                    if (this.didMount) {
                        this.setState({ suggestions, suggestionIndex: -1 });
                        if (setIsEmptySuggestions) {
                            setIsEmptySuggestions(!suggestions.length);
                        }
                        const selectedIdx = suggestions === null || suggestions === void 0 ? void 0 : suggestions.findIndex((suggestion) => (suggestion === null || suggestion === void 0 ? void 0 : suggestion.value) === initialValue);
                        if (selectedIdx !== -1) {
                            this.setState({
                                query: (_a = suggestions[selectedIdx]) === null || _a === void 0 ? void 0 : _a.value,
                                inputQuery: (_b = suggestions[selectedIdx]) === null || _b === void 0 ? void 0 : _b.value,
                                cachedQuery: (_c = suggestions[selectedIdx]) === null || _c === void 0 ? void 0 : _c.value,
                            });
                            if (onChange) {
                                onChange(suggestions[selectedIdx]);
                            }
                        }
                    }
                }, customRequest, setIsLoading);
            }
        };
        this.getSuggestionsUrl = () => {
            const { url } = this.props;
            return url || this.loadSuggestionsUrl;
        };
        this.debounce = (callback, ms) => {
            return () => {
                clearTimeout(this.timeout);
                this.timeout = window.setTimeout(() => {
                    callback();
                }, ms);
            };
        };
        this.setupDebounce = (delay) => {
            if (typeof delay === 'number' && delay > 0) {
                this.fetchSuggestions = this.debounce(this.performFetchSuggestions, delay);
            }
            else {
                this.fetchSuggestions = this.performFetchSuggestions;
            }
        };
        this.fetchSuggestions = () => {
        };
        this.handleInputFocus = (event) => {
            this.setState({ isFocused: true });
            const { suggestions, query } = this.state;
            const { isExpandedOnFocus } = this.props;
            if (suggestions && suggestions.length === 0) {
                this.fetchSuggestions();
            }
            if (isExpandedOnFocus && !(suggestions === null || suggestions === void 0 ? void 0 : suggestions.length)) {
                this.fetchSuggestions();
            }
            const { inputProps } = this.props;
            if (inputProps && inputProps.onFocus) {
                inputProps.onFocus(event);
            }
            if (query.length && !suggestions) {
                this.setState({ suggestions: [] });
            }
        };
        this.handleInputBlur = (event) => {
            const { suggestions, suggestionIndex, cachedQuery } = this.state;
            const { selectOnBlur, inputProps } = this.props;
            this.setState({ isFocused: false });
            if (selectOnBlur && !this.dontPerformBlurHandler) {
                if (suggestions && suggestions.length > 0) {
                    const suggestionIndexToSelect = suggestionIndex >= 0 && suggestionIndex < suggestions.length
                        ? suggestionIndex
                        : 0;
                    this.selectSuggestion(suggestionIndexToSelect, true);
                }
                else {
                    this.setState({
                        query: cachedQuery,
                        inputQuery: cachedQuery,
                    });
                }
            }
            this.dontPerformBlurHandler = false;
            if (inputProps && inputProps.onBlur) {
                inputProps.onBlur(event);
            }
            this.resetBodyHeight();
        };
        this.handleInputChange = (event) => {
            var _a;
            const { setIsTypingStatus } = this.props;
            if (event &&
                setIsTypingStatus &&
                !setIsTypingStatus(event)) {
                return;
            }
            let customEvent = event;
            if (!((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) && typeof event === 'string') {
                customEvent = Object.assign(Object.assign({}, customEvent), { target: Object.assign(Object.assign({}, customEvent.target), { value: event }) });
            }
            const { value } = customEvent.target;
            const { inputProps } = this.props;
            if (this.didMount) {
                this.setState({ query: value, inputQuery: value, displaySuggestions: !!value }, () => {
                    this.fetchSuggestions();
                });
            }
            if (inputProps && inputProps.onChange) {
                inputProps.onChange(customEvent);
            }
        };
        this.handleInputKeyDown = (event) => {
            this.handleKeyboard(event);
            const { inputProps } = this.props;
            if (inputProps && inputProps.onKeyDown) {
                inputProps.onKeyDown(event);
            }
        };
        this.handleInputKeyPress = (event) => {
            this.handleKeyboard(event);
            const { inputProps } = this.props;
            if (inputProps && inputProps.onKeyPress) {
                inputProps.onKeyPress(event);
            }
        };
        this.updateScroll = (newSuggestionIndex) => {
            var _a;
            const listBox = this.listBoxRef.current;
            const selectedOption = (_a = this.optionsRefs[newSuggestionIndex]) === null || _a === void 0 ? void 0 : _a.current;
            if (selectedOption &&
                listBox &&
                listBox.scrollHeight > listBox.clientHeight) {
                const scrollBottom = listBox.clientHeight + listBox.scrollTop;
                const elementBottom = selectedOption.offsetTop + selectedOption.offsetHeight;
                if (elementBottom > scrollBottom) {
                    listBox.scrollTop = elementBottom - listBox.clientHeight;
                }
                else if (selectedOption.offsetTop < listBox.scrollTop) {
                    listBox.scrollTop = selectedOption.offsetTop;
                }
            }
        };
        this.handleKeyboard = (event) => {
            const { suggestions, suggestionIndex, inputQuery } = this.state;
            if (event.which === 40 && suggestions) {
                event.preventDefault();
                if (suggestionIndex < suggestions.length - 1) {
                    const newSuggestionIndex = suggestionIndex + 1;
                    const newInputQuery = suggestions[newSuggestionIndex].value;
                    if (this.didMount) {
                        this.setState({
                            suggestionIndex: newSuggestionIndex,
                            query: newInputQuery,
                        });
                    }
                    this.updateScroll(newSuggestionIndex);
                }
            }
            else if (event.which === 38 && suggestions) {
                event.preventDefault();
                if (suggestionIndex >= 0) {
                    const newSuggestionIndex = suggestionIndex - 1;
                    const newInputQuery = newSuggestionIndex === -1
                        ? inputQuery
                        : suggestions[newSuggestionIndex].value;
                    if (this.didMount) {
                        this.setState({
                            suggestionIndex: newSuggestionIndex,
                            query: newInputQuery,
                        });
                    }
                    this.updateScroll(newSuggestionIndex);
                }
            }
            else if (event.which === 13) {
                event.preventDefault();
                if (suggestionIndex >= 0) {
                    this.selectSuggestion(suggestionIndex);
                }
            }
        };
        this.performFetchSuggestions = () => {
            const { minChars, token, customRequest, setIsLoading, setIsEmptySuggestions, isDisableRequests, } = this.props;
            const { query } = this.state;
            if (isDisableRequests)
                return;
            if (typeof minChars === 'number' &&
                minChars > 0 &&
                query.length < minChars) {
                this.setState({ suggestions: [], suggestionIndex: -1 });
                if (setIsEmptySuggestions) {
                    setIsEmptySuggestions(true);
                }
                return;
            }
            if (token) {
                this.headers = Object.assign(Object.assign({}, this.headers), { Authorization: `Token ${token}` });
            }
            (0, request_1.makeRequest)('POST', this.getSuggestionsUrl(), {
                headers: this.headers,
                json: this.getLoadSuggestionsData(),
            }, this.httpCache, (suggestions) => {
                if (this.didMount) {
                    this.setState({ suggestions, suggestionIndex: -1 });
                    if (setIsEmptySuggestions) {
                        setIsEmptySuggestions(!suggestions.length);
                    }
                }
            }, customRequest, setIsLoading);
        };
        this.onSuggestionClick = (index, event) => {
            event.stopPropagation();
            this.selectSuggestion(index);
        };
        this.selectSuggestion = (index, isSilent = false) => {
            var _a;
            const { suggestions } = this.state;
            const { selectOnBlur, onChange, setInputValue } = this.props;
            if (suggestions && suggestions.length >= index - 1) {
                const suggestion = suggestions[index];
                if (selectOnBlur) {
                    this.dontPerformBlurHandler = true;
                }
                this.setState({
                    query: setInputValue ? setInputValue(suggestion) : suggestion.value,
                    cachedQuery: setInputValue
                        ? setInputValue(suggestion)
                        : suggestion.value,
                    inputQuery: suggestion.value,
                    displaySuggestions: false,
                }, () => {
                    if (!isSilent) {
                        this.fetchSuggestions();
                    }
                });
                if (onChange) {
                    onChange(suggestion);
                }
                this.resetBodyHeight();
            }
            (_a = this.textInput) === null || _a === void 0 ? void 0 : _a.blur();
            this.setState({ isFocused: false });
        };
        this.getHighlightWords = () => {
            const { inputQuery } = this.state;
            const wordsToPass = [
                'г',
                'респ',
                'ул',
                'р-н',
                'село',
                'деревня',
                'поселок',
                'пр-д',
                'пл',
                'к',
                'кв',
                'обл',
                'д',
            ];
            let words = inputQuery.replace(',', '').split(' ');
            words = words.filter((word) => {
                return wordsToPass.indexOf(word) < 0;
            });
            return words;
        };
        this.getSuggestionKey = (suggestion) => suggestion.value;
        this.focus = () => {
            if (this.textInput) {
                this.textInput.focus();
            }
        };
        this.setInputValue = (value) => {
            this.setState({ query: value || '', inputQuery: value || '' });
        };
        this.setListBoxWrapperRef = (element) => {
            var _a, _b;
            if (this.isTopFrame())
                return;
            if (element) {
                (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(element);
            }
            else
                (_b = this.resizeObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
        };
        this.isOptionsExpanded = () => {
            const { isFocused, suggestions, displaySuggestions } = this.state;
            const { isExpandedOnFocus } = this.props;
            return ((isFocused &&
                suggestions &&
                (displaySuggestions || isExpandedOnFocus) &&
                !!suggestions.length) ||
                this.isShowEmptyMessage());
        };
        this.isShowEmptyMessage = () => {
            const { isFocused, suggestions } = this.state;
            return (this.props.emptyMessage &&
                ((suggestions && !suggestions.length) || (!isFocused && !suggestions)));
        };
        this.resetBodyHeight = () => (document.body.style.height = '');
        this.isTopFrame = () => window.top === window;
        this.didMount = false;
        this.listBoxRef = (0, react_1.createRef)();
        this.optionsRefs = [];
        this.resizeObserver = null;
        const { defaultQuery, value, delay } = this.props;
        const valueQuery = value ? value.value : undefined;
        this.setupDebounce(delay);
        this.state = {
            query: defaultQuery || valueQuery || '',
            inputQuery: defaultQuery || valueQuery || '',
            cachedQuery: defaultQuery || valueQuery || '',
            isFocused: false,
            displaySuggestions: true,
            suggestionIndex: -1,
        };
    }
    componentDidMount() {
        const { initialValue, isPossibleOverflow } = this.props;
        this.didMount = true;
        if (initialValue) {
            this.getInitialValues();
        }
        if (this.isTopFrame() || !isPossibleOverflow)
            return;
        let isOverflow = false;
        this.resizeObserver = new ResizeObserver((entries) => {
            const listBoxWrapper = entries[0].target;
            const DOMRectBody = document.body.getBoundingClientRect();
            const DOMRectListBoxWrapper = listBoxWrapper.getBoundingClientRect();
            if (DOMRectBody.bottom <= DOMRectListBoxWrapper.bottom) {
                document.body.style.height =
                    DOMRectBody.bottom +
                        (DOMRectListBoxWrapper.bottom - DOMRectBody.bottom) +
                        PADDING_OVERFLOW +
                        DIMENSION;
                isOverflow = true;
            }
            else if (isOverflow && this.isOptionsExpanded()) {
                document.body.style.height =
                    DOMRectListBoxWrapper.bottom + PADDING_OVERFLOW + DIMENSION;
                isOverflow = false;
            }
        });
    }
    componentDidUpdate(prevProps) {
        const { value, delay, initialValue, setIsShowSuggestions, setIsEmptySuggestions, isDisableRequests, isExpandedOnFocus, } = this.props;
        const { query, inputQuery, isFocused, suggestions, displaySuggestions } = this.state;
        if (!(0, utils_1.shallowEqual)(prevProps.value, value)) {
            const newQuery = value ? value.value : '';
            if (query !== newQuery || inputQuery !== newQuery) {
                this.setState({
                    query: newQuery,
                    inputQuery: newQuery,
                    cachedQuery: newQuery,
                });
            }
            if (displaySuggestions) {
                this.setState({ displaySuggestions: !!newQuery });
            }
        }
        if (delay !== prevProps.delay) {
            this.setupDebounce(delay);
        }
        if (initialValue && !(0, utils_1.shallowEqual)(prevProps.initialValue, initialValue)) {
            this.getInitialValues();
        }
        if (setIsShowSuggestions) {
            setIsShowSuggestions(isFocused &&
                !!suggestions &&
                (displaySuggestions || !!isExpandedOnFocus) &&
                suggestions.length > 0);
        }
        if (suggestions && !query && !isExpandedOnFocus) {
            this.setState({ suggestions: undefined });
            if (setIsEmptySuggestions && !isDisableRequests) {
                setIsEmptySuggestions(true);
            }
        }
        if (this.resizeObserver &&
            isFocused &&
            !this.isOptionsExpanded() &&
            document.body.style.height) {
            this.resetBodyHeight();
        }
    }
    componentWillUnmount() {
        this.didMount = false;
        if (this.resizeObserver)
            this.resizeObserver.disconnect();
    }
    get uid() {
        if (this.props.uid) {
            return this.props.uid;
        }
        if (!this._uid) {
            this._uid = (0, uuid_1.v4)();
        }
        return this._uid;
    }
    get httpCache() {
        const { httpCache: cacheProp, httpCacheTtl: ttl } = this.props;
        if (!cacheProp) {
            return null;
        }
        if (cacheProp instanceof http_cache_1.HttpCache) {
            return cacheProp;
        }
        const cache = http_cache_1.DefaultHttpCache.shared;
        if (typeof ttl === 'number') {
            cache.ttl = ttl;
        }
        return cache;
    }
    render() {
        const { inputProps, hintText, containerClassName, hintClassName, suggestionsClassName, suggestionClassName, currentSuggestionClassName, customInput, children, isCapitalizeFirst, emptyMessage, } = this.props;
        const { query, isFocused, suggestions, suggestionIndex } = this.state;
        const Component = typeof customInput !== 'undefined' ? customInput : input_1.Input;
        const optionsExpanded = this.isOptionsExpanded();
        return (react_1.default.createElement(react_dadata_styles_1.StyledContainer, { role: "combobox", "aria-expanded": optionsExpanded ? 'true' : 'false', "aria-owns": this.uid, "aria-controls": this.uid, "aria-haspopup": "listbox", className: containerClassName },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Component, Object.assign({ autoComplete: "off" }, inputProps, { value: isCapitalizeFirst ? (0, utils_1.capitalizeFirst)(query) : query, ref: (input) => {
                        this.textInput = input;
                    }, onChange: this.handleInputChange, onKeyPress: this.handleInputKeyPress, onKeyDown: this.handleInputKeyDown, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur }))),
            optionsExpanded && (react_1.default.createElement(react_dadata_styles_1.StyledSuggestionWrapper, { ref: this.setListBoxWrapperRef, isFocused: isFocused },
                react_1.default.createElement(react_dadata_styles_1.StyledSuggestions, { id: this.uid, "aria-expanded": true, role: "listbox", ref: this.listBoxRef, className: suggestionsClassName },
                    typeof hintText !== 'undefined' && (react_1.default.createElement(react_dadata_styles_1.StyledSuggestionNote, { className: hintClassName }, hintText)),
                    this.isShowEmptyMessage() && emptyMessage, suggestions === null || suggestions === void 0 ? void 0 :
                    suggestions.map((suggestion, index) => {
                        this.optionsRefs[index] = (0, react_1.createRef)();
                        let suggestionClass = suggestionClassName;
                        if (index === suggestionIndex &&
                            suggestionClassName &&
                            currentSuggestionClassName) {
                            suggestionClass =
                                suggestionClassName + currentSuggestionClassName;
                        }
                        return (react_1.default.createElement(react_dadata_styles_1.StyledSuggestion, { role: "option", ref: this.optionsRefs[index], isSelected: index === suggestionIndex, "aria-selected": index === suggestionIndex ? 'true' : 'false', key: this.getSuggestionKey(suggestion), onMouseDown: this.onSuggestionClick.bind(this, index), className: suggestionClass }, this.renderOption(suggestion)));
                    })))),
            children));
    }
}
exports.BaseSuggestions = BaseSuggestions;
